const toPageField = (page: string) => `field_${page}_`

const pageTypes = { adFormats: 'ad_spec_page', standard: 'standard_page' }
const pages = {
  adFormats: toPageField(pageTypes.adFormats),
  standard: toPageField(pageTypes.standard)
}

const adFormatsHeaderFields = {
  backgroundColor: pages.adFormats + 'header_backgr',
  image: pages.adFormats + 'header_image',
  platformCategory: pages.adFormats + 'header_platfo',
  digitalAdFormatSuite: pages.adFormats + 'header_digita'
}

const adFormatsLayoutFields = {
  layout: 'field_ad_formats_layout',
  image: 'field_ad_formats_layout.field_ad_format_layout_image',
  assetList: 'field_ad_formats_layout.field_ad_format_layout_asset_lis'
}

const adFormatsTechnicalSpecFields = {
  spec: 'field_ad_formats_technical_speci'
}

const adFormatsPageDetails = {
  platform: { label: 'Platform', path: pages.adFormats + 'detail_platfo', included: true },
  dealType: { label: 'Deal Type', path: pages.adFormats + 'detail_deal', included: true },
  device: { label: 'Device', path: pages.adFormats + 'detail_device', included: false },
  targeting: { label: 'Targeting', path: pages.adFormats + 'detail_target', included: false },
  video: { label: 'Video', path: pages.adFormats + 'detail_video', included: false },
  centreBreak: { label: 'Center Break', path: pages.adFormats + 'detail_centre', included: false },
  contentBundle: {
    label: 'Content Bundle',
    path: pages.adFormats + 'detail_conten',
    included: false
  },
  frequencyCapping: {
    label: 'Frequency Capping',
    path: pages.adFormats + 'detail_freq',
    included: false
  },
  responsive: { label: 'Responsive', path: pages.adFormats + 'detail_respon', included: false },
  endBreak: { label: 'End Break', path: pages.adFormats + 'detail_end', included: false },
  genre: { label: 'Genre', path: pages.adFormats + 'detail_genre', included: false },
  programme: { label: 'Programme', path: pages.adFormats + 'detail_prog', included: false },
  channel: { label: 'Channel', path: pages.adFormats + 'detail_chann', included: false },
  dateTime: { label: 'Date & Time', path: pages.adFormats + 'detail_date', included: false }
}

const standardParagraphFields = {
  image: 'field_image',
  bannerImages: 'field_banner_images',
  bannerImagesImage: 'field_banner_images.field_image_image',
  bannerButton: 'field_banner_button_file',
  bannerButtonRef: 'field_banner_button_content_refe',
  stat: 'field_stat',
  gallery: 'field_gallery_images_and_labels',
  galleryImagesLabels: 'field_gallery_images_and_labels.field_image_and_label_image',
  tabs: 'field_tabs',
  tabsButton: 'field_tabs.field_tab_button_content_referen',
  tabsImage: 'field_tabs.field_tab_image',
  card: 'field_card_content_reference',
  cardHeader: 'field_card_content_reference.field_standard_page_header',
  cardImage: 'field_card_content_reference.field_standard_page_header.field_page_header_image',
  cardTaxonmy: 'field_card_content_reference.field_page_type_taxonomy',
  promoCard: 'field_promo_card',
  promoCardImage: 'field_promo_card.field_promo_card_image'
}

const adFormatsListIncludes = [
  pages.adFormats + 'header',
  ...Object.values(adFormatsHeaderFields)
    .slice(1, 4)
    .map(v => `${pages.adFormats}header.${v}`)
]

const includes = {
  adFormatsList: adFormatsListIncludes,
  adformats: [
    ...Object.values(adFormatsHeaderFields)
      .slice(1, 4)
      .map(v => `${pages.adFormats}header.${v}`),
    ...Object.values(adFormatsPageDetails).map(v => `${pages.adFormats}detailed_info.${v.path}`),
    ...Object.values(adFormatsLayoutFields),
    ...Object.values(adFormatsTechnicalSpecFields),
    'field_ad_spec_page_optional'
  ],
  standard: [
    ...Object.values(standardParagraphFields).map(v => `field_standard_paragraph.${v}`),
    'field_page_type_taxonomy',
    'field_standard_paragraph',
    'field_standard_page_header',
    'field_standard_page_header.field_page_header_image'
  ],
  home: ['field_info_section']
}

export { pageTypes, pages, adFormatsHeaderFields, adFormatsPageDetails, includes }
